export type PendingVerification = {
  email: string;
  expiresAt: number;
  resendAt: number;
};

const storageKey = "restatic:pending-email-verification";
const registrationLifetimeMs = 24 * 60 * 60 * 1000;
export const resendCooldownMs = 60 * 1000;

export const readPendingVerification = (): PendingVerification | null => {
  try {
    const value = window.localStorage.getItem(storageKey);
    if (!value) return null;
    const pending: PendingVerification = JSON.parse(value);
    if (
      typeof pending.email === "string" &&
      pending.email.length > 0 &&
      Number.isFinite(pending.expiresAt) &&
      pending.expiresAt > Date.now() &&
      Number.isFinite(pending.resendAt)
    ) {
      return pending;
    }
    window.localStorage.removeItem(storageKey);
  } catch {
    // The form still works when storage is unavailable.
  }
  return null;
};

export const savePendingVerification = (pending: PendingVerification): void => {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(pending));
  } catch {
    // The current page can continue without persistent storage.
  }
};

export const newPendingVerification = (email: string): PendingVerification => {
  const now = Date.now();
  return { email, expiresAt: now + registrationLifetimeMs, resendAt: now + resendCooldownMs };
};

export const clearPendingVerification = (email: string): void => {
  const pending = readPendingVerification();
  if (!pending || pending.email.toLowerCase() !== email.trim().toLowerCase()) return;
  try {
    window.localStorage.removeItem(storageKey);
  } catch {
    // Storage cleanup is best effort.
  }
};
